export default __webpack_public_path__ + "static/media/ce-covid19homestudies.d4556a14.png";